__turbopack_context__.v({
  "active": "TaggedImageBlok-module__3WSrTW__active",
  "blok-big-title": "TaggedImageBlok-module__3WSrTW__blok-big-title",
  "blok-subtitle": "TaggedImageBlok-module__3WSrTW__blok-subtitle",
  "blok-title": "TaggedImageBlok-module__3WSrTW__blok-title",
  "image": "TaggedImageBlok-module__3WSrTW__image",
  "slideUpAndFade": "TaggedImageBlok-module__3WSrTW__slideUpAndFade",
  "tag": "TaggedImageBlok-module__3WSrTW__tag",
  "tagCardContent": "TaggedImageBlok-module__3WSrTW__tagCardContent",
  "tag__client": "TaggedImageBlok-module__3WSrTW__tag__client",
  "wrapper": "TaggedImageBlok-module__3WSrTW__wrapper",
});
